import Dialog from "../../atoms/dialog";
import { Button, Typography, Box } from "@material-ui/core";
import { useState, useEffect, Fragment } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import DeleteSimulationTransaction from "../simulations/DeleteSimulationTransaction";



const DeleteSimulationTransactionAlert = (props) => {
    const { onCompletion, element, onClose } = props;

    const [open, setOpen] = useState(false)


    const handleClose = () => {
        setOpen(false);
        onClose();
    }

    return (

        <Dialog
            // title={"Delete"}
            open={true}
            handleClose={handleClose}
            paperProps={{ id: "deleteTransactionAlert" }}
        >

            <DeleteSimulationTransaction onCompletion={onCompletion} element={element} onClose={onClose} />

        </Dialog >
    )

}

export default DeleteSimulationTransactionAlert;